const data = {
    type: 'Topology',
    arcs: [
        [
            [2218, 4470],
            [-91, -13],
        ],
        [
            [2127, 4457],
            [-27, 75],
            [5, 250],
            [-22, 23],
            [-4, 53],
            [-38, 38],
            [-33, 32],
            [14, 57],
        ],
        [
            [2022, 4985],
            [37, 13],
            [23, 47],
            [53, 11],
            [24, 32],
        ],
        [
            [2159, 5088],
            [37, 32],
            [39, 0],
            [83, -62],
        ],
        [
            [2318, 5058],
            [-4, -37],
            [24, -64],
            [-21, -44],
            [11, -29],
            [-53, -68],
            [-33, -33],
            [-21, -69],
            [3, -69],
            [-6, -175],
        ],
        [
            [4534, 2600],
            [11, -34],
            [-12, -53],
            [19, -51],
            [-16, -41],
            [9, -37],
            [-227, 1],
            [-5, -346],
            [73, -89],
            [72, -68],
        ],
        [
            [4458, 1882],
            [-201, -44],
            [-264, 15],
            [-76, 52],
            [-442, -4],
            [-17, -8],
            [-65, 49],
            [-71, 3],
            [-65, -18],
            [-52, -21],
        ],
        [
            [3205, 1906],
            [-11, 69],
            [15, 95],
            [38, 100],
            [6, 47],
            [35, 98],
            [26, 44],
            [63, 71],
            [35, 49],
            [11, 80],
            [-5, 62],
            [-33, 39],
            [-29, 66],
            [-27, 65],
            [6, 23],
            [34, 43],
            [-34, 105],
            [-22, 73],
            [-55, 69],
            [11, 21],
        ],
        [
            [3269, 3125],
            [45, 15],
            [31, -2],
            [39, 13],
            [322, -2],
            [27, -81],
            [31, -65],
            [25, -35],
            [42, -57],
            [72, 9],
            [36, 15],
            [60, -15],
            [17, 27],
            [27, 63],
            [68, 4],
            [6, 19],
            [55, 1],
            [-9, -39],
            [132, 0],
            [2, -68],
            [23, -42],
            [-17, -66],
            [8, -67],
            [37, -40],
            [-6, -129],
            [27, 10],
            [47, -3],
            [68, 16],
            [50, -6],
        ],
        [
            [3253, 3159],
            [-29, 82],
        ],
        [
            [3224, 3241],
            [44, 47],
            [33, 18],
            [41, -37],
        ],
        [
            [3342, 3269],
            [-40, -23],
            [-17, -28],
            [-4, -48],
            [-28, -11],
        ],
        [
            [1612, 4332],
            [-50, -1],
            [-76, 21],
            [-70, -1],
            [-129, -19],
            [-76, -31],
            [-108, -40],
            [-21, 3],
        ],
        [
            [1082, 4264],
            [8, 89],
            [11, 14],
            [-4, 43],
            [-46, 45],
            [-34, 8],
            [-32, 30],
            [23, 48],
            [-10, 53],
            [5, 31],
        ],
        [
            [1003, 4625],
            [17, 0],
            [6, 48],
            [-8, 21],
            [10, 15],
            [41, 13],
            [-27, 87],
            [-25, 45],
            [9, 37],
            [21, 8],
        ],
        [
            [1047, 4899],
            [15, 10],
            [30, -16],
            [84, -1],
            [20, 32],
            [19, -2],
            [31, 12],
            [17, -47],
            [26, 14],
            [45, 16],
        ],
        [
            [1334, 4917],
            [49, -23],
            [19, -36],
            [49, -23],
            [38, 27],
            [51, 4],
            [75, -28],
        ],
        [
            [1615, 4838],
            [29, -155],
            [-46, -91],
            [-28, -123],
            [47, -94],
            [-5, -43],
        ],
        [
            [5136, 1385],
            [-154, -80],
            [-98, -81],
            [-37, -73],
            [-32, -41],
            [-60, -9],
            [-19, -52],
            [-11, -34],
            [-70, -25],
            [-89, 6],
            [-52, 30],
            [-46, 13],
            [-53, -25],
            [-27, -52],
            [-51, -33],
            [-55, -48],
            [-78, -12],
            [-25, 39],
            [11, 66],
            [-65, 103],
            [-30, 17],
        ],
        [
            [4095, 1094],
            [0, 317],
            [108, 4],
            [3, 388],
            [81, 3],
            [169, 38],
            [41, -44],
            [70, 42],
            [33, 0],
            [62, 25],
        ],
        [
            [4662, 1867],
            [19, -8],
        ],
        [
            [4681, 1859],
            [42, -87],
            [22, -20],
            [35, -63],
            [123, -119],
            [47, -12],
            [0, -38],
            [32, -69],
            [85, -17],
            [69, -49],
        ],
        [
            [3224, 3241],
            [-89, 115],
        ],
        [
            [3135, 3356],
            [83, 60],
            [-41, 72],
            [37, 27],
            [74, 14],
            [8, 48],
            [59, -52],
            [96, -5],
            [34, 51],
            [13, 73],
            [-12, 85],
            [-51, 64],
            [47, 126],
            [-27, 22],
            [-81, -9],
            [-31, 56],
            [8, 47],
        ],
        [
            [3351, 4035],
            [138, -4],
            [88, -28],
            [87, -26],
            [8, 59],
        ],
        [
            [3672, 4036],
            [57, 101],
            [65, 57],
            [74, -18],
            [70, -6],
        ],
        [
            [3938, 4170],
            [-7, -66],
            [-32, -58],
            [-22, -68],
            [-13, -96],
            [6, -62],
            [-18, -38],
            [-3, -39],
            [-13, -35],
            [-71, -53],
            [-50, -56],
            [-48, -105],
            [4, -90],
            [-28, -35],
            [-63, -53],
            [-65, -68],
            [-40, 19],
            [-7, 31],
            [-60, 1],
            [-37, -42],
            [-29, 12],
        ],
        [
            [3351, 4035],
            [-14, 6],
            [-64, -14],
            [-67, 15],
            [-51, -7],
        ],
        [
            [3155, 4035],
            [-178, 2],
        ],
        [
            [2977, 4037],
            [16, 86],
            [-43, 72],
            [-50, 19],
            [-22, 48],
            [-28, 16],
            [2, 30],
        ],
        [
            [2852, 4308],
            [28, 77],
            [52, 105],
            [31, 1],
            [65, 64],
            [42, 2],
            [61, -45],
            [75, 36],
            [10, 46],
            [25, 44],
            [16, 55],
            [59, 44],
            [22, 77],
            [23, 24],
            [15, 56],
            [29, 70],
            [92, 84],
            [6, 36],
            [12, 20],
            [-43, 43],
        ],
        [
            [3472, 5147],
            [3, 35],
            [31, 6],
        ],
        [
            [3506, 5188],
            [43, -70],
            [8, -72],
            [-4, -72],
            [59, -99],
            [-61, 1],
            [-31, -8],
            [-49, 11],
            [-24, -51],
            [64, -64],
            [48, -18],
            [15, -45],
            [35, -75],
            [-17, -30],
        ],
        [
            [3592, 4596],
            [-55, -110],
            [-27, -20],
            [-8, -84],
            [11, -46],
            [-9, -32],
            [52, -57],
            [9, -39],
            [40, -56],
            [50, -35],
            [5, -50],
            [12, -31],
        ],
        [
            [3592, 4596],
            [90, 9],
            [20, 28],
            [18, -3],
            [27, -24],
            [138, 41],
            [46, 43],
            [57, 38],
            [-11, 38],
            [31, 10],
            [105, -6],
            [103, 50],
            [79, 119],
            [55, 44],
            [69, 18],
        ],
        [
            [4419, 5001],
            [13, -46],
            [63, -68],
            [0, -45],
            [-18, -45],
            [7, -34],
            [38, -31],
            [9, -5],
        ],
        [
            [4531, 4727],
            [74, -43],
            [60, -44],
            [1, -35],
            [73, -57],
            [46, -47],
            [28, -65],
            [81, -43],
            [18, -35],
        ],
        [
            [4912, 4358],
            [-36, -11],
            [-70, 2],
            [-83, 12],
            [-40, -10],
            [-16, -26],
            [-36, -3],
            [-43, 23],
            [-121, -55],
            [-50, 11],
            [-15, -8],
            [-33, -66],
            [-81, 21],
            [-80, 11],
            [-70, 40],
            [-89, 37],
            [-59, -35],
            [-42, -55],
            [-10, -76],
        ],
        [
            [2022, 4985],
            [-96, 3],
        ],
        [
            [1926, 4988],
            [-50, 8],
            [-35, -17],
            [-49, 8],
            [-189, -5],
            [-3, -62],
            [15, -82],
        ],
        [
            [1334, 4917],
            [-7, 63],
            [29, 47],
            [-2, 36],
            [87, 91],
            [16, 74],
            [29, 27],
            [53, -15],
            [46, 22],
            [15, 28],
            [85, 49],
            [20, 34],
            [102, 45],
            [60, 16],
            [28, -21],
            [70, 0],
        ],
        [
            [1965, 5413],
            [-9, -52],
            [15, -50],
            [61, -71],
            [4, -53],
            [125, -24],
            [-2, -75],
        ],
        [
            [5126, 3299],
            [-7, 131],
            [-27, 50],
        ],
        [
            [5092, 3480],
            [66, -9],
            [34, 62],
            [58, -7],
        ],
        [
            [5250, 3526],
            [6, -43],
            [23, -24],
            [1, -36],
            [-27, -23],
            [-42, -56],
            [-40, -40],
            [-45, -5],
        ],
        [
            [6626, 5171],
            [26, -34],
            [-4, -45],
            [-62, -26],
            [47, -30],
        ],
        [
            [6633, 5036],
            [-40, -58],
        ],
        [
            [6593, 4978],
            [-24, 19],
            [-27, -8],
            [-61, 2],
            [-1, 33],
            [-9, 30],
            [37, 51],
            [38, 49],
        ],
        [
            [6546, 5154],
            [47, -10],
            [33, 27],
        ],
        [
            [2390, 5873],
            [-122, -10],
            [-1, 69],
            [-50, 17],
            [-68, 32],
            [-26, 51],
            [-368, 237],
            [-369, 237],
        ],
        [
            [1386, 6506],
            [-410, 264],
        ],
        [
            [976, 6770],
            [2, 21],
            [0, 7],
        ],
        [
            [978, 6798],
            [-1, 129],
            [176, 80],
            [109, 17],
            [90, 29],
            [41, 55],
            [128, 43],
            [5, 80],
            [63, 10],
            [49, 40],
            [143, 18],
            [20, 43],
            [-29, 23],
            [-37, 115],
            [-7, 66],
            [-41, 70],
        ],
        [
            [1687, 7616],
            [105, 59],
            [118, 19],
            [69, 45],
            [105, 33],
            [185, 19],
            [180, 9],
            [55, -16],
            [103, 43],
            [117, 1],
            [44, -26],
            [75, 7],
        ],
        [
            [2843, 7809],
            [-22, -56],
            [17, -103],
            [-26, -90],
            [-67, -61],
            [10, -82],
            [89, -65],
            [1, -26],
            [67, -44],
            [47, -195],
        ],
        [
            [2959, 7087],
            [35, -96],
            [6, -51],
            [-19, -89],
            [8, -49],
            [-14, -60],
            [9, -68],
            [-43, -46],
            [65, -79],
            [4, -47],
            [38, -60],
            [51, 20],
            [87, -51],
            [48, -68],
        ],
        [
            [3234, 6343],
            [-375, -208],
            [-316, -213],
            [-153, -49],
        ],
        [
            [6218, 5370],
            [75, -1],
            [95, -44],
            [28, -37],
            [48, -35],
            [45, -64],
            [37, -35],
        ],
        [
            [6593, 4978],
            [-24, -39],
            [40, -60],
            [41, -52],
            [41, -39],
            [357, -129],
            [92, 1],
        ],
        [
            [7140, 4660],
            [-308, -327],
            [-143, -5],
            [-97, -76],
            [-70, -2],
            [-30, -35],
        ],
        [
            [6492, 4215],
            [-74, 0],
            [-44, 37],
            [-100, -45],
            [-32, -46],
            [-73, 9],
            [-24, 12],
            [-26, -3],
            [-34, 1],
            [-139, 93],
            [-75, 0],
            [-38, 36],
            [0, 61],
            [-56, 18],
        ],
        [
            [5777, 4388],
            [-65, 118],
            [-50, 26],
            [-19, 43],
            [-55, 53],
            [-67, 8],
            [37, 62],
            [58, 3],
            [16, 33],
            [-1, 85],
        ],
        [
            [5631, 4819],
            [0, 13],
            [32, 114],
            [52, 30],
            [11, 44],
            [46, 84],
            [66, 53],
            [45, 108],
            [17, 93],
        ],
        [
            [5900, 5358],
            [127, -23],
            [34, 82],
            [66, -50],
            [64, 26],
            [27, -23],
        ],
        [
            [3135, 3356],
            [-113, 110],
            [-72, 89],
            [-66, 113],
            [4, 36],
            [23, 35],
            [27, 79],
            [22, 81],
        ],
        [
            [2960, 3899],
            [37, 6],
            [159, -1],
            [-1, 131],
        ],
        [
            [1003, 4625],
            [-31, 3],
            [-23, -44],
            [-30, 1],
            [-22, 23],
            [8, 44],
            [-46, 66],
            [-29, -12],
            [-23, -2],
        ],
        [
            [807, 4704],
            [-30, -7],
            [1, 40],
            [-17, 29],
            [3, 31],
            [-23, 46],
            [-31, 39],
            [-87, 0],
            [-25, -20],
            [-31, -3],
            [-18, -23],
            [-13, -31],
            [-58, -47],
        ],
        [
            [478, 4758],
            [-48, 64],
            [-42, 43],
            [-28, 14],
            [-28, 21],
            [-12, 48],
            [-16, 24],
            [-32, 18],
        ],
        [
            [272, 4990],
            [49, 53],
            [33, -2],
            [28, 18],
            [24, 1],
            [18, 14],
            [-10, 36],
            [12, 11],
            [2, 37],
        ],
        [
            [428, 5158],
            [53, -1],
            [78, -26],
            [25, 2],
            [8, 12],
            [59, -8],
            [16, 6],
        ],
        [
            [667, 5143],
            [6, -40],
            [18, 0],
            [28, 15],
            [18, -4],
            [31, -28],
            [46, -8],
            [30, 23],
            [35, 15],
            [27, 15],
            [22, -3],
            [24, -24],
            [13, -30],
            [44, -45],
            [-22, -28],
            [-4, -36],
            [23, 11],
            [14, -13],
            [-6, -32],
            [33, -32],
        ],
        [
            [1926, 4988],
            [-8, -34],
            [46, -56],
            [0, -79],
            [10, -86],
            [27, -40],
            [-24, -98],
            [9, -54],
            [29, -69],
            [24, -38],
        ],
        [
            [2039, 4434],
            [-171, -64],
            [-60, -37],
            [-99, -32],
            [-97, 31],
        ],
        [
            [5900, 5358],
            [-12, 44],
            [47, 160],
            [11, 72],
            [35, 33],
            [80, 18],
            [55, 62],
        ],
        [
            [6116, 5747],
            [64, -126],
            [30, -100],
            [59, -53],
            [149, -102],
            [61, -62],
            [59, -63],
            [34, -38],
            [54, -32],
        ],
        [
            [3269, 3125],
            [-16, 34],
        ],
        [
            [4912, 4358],
            [66, -89],
            [49, -14],
            [29, 19],
            [50, -8],
            [61, 23],
            [26, -46],
            [96, -72],
        ],
        [
            [5289, 4171],
            [0, 0],
            [-6, -128],
            [43, -14],
            [-35, -39],
            [-42, -29],
            [-41, -57],
            [-23, -50],
            [-6, -88],
            [-26, -41],
            [-1, -82],
        ],
        [
            [5152, 3643],
            [-31, -30],
            [-4, -65],
            [-15, -9],
            [-10, -59],
        ],
        [
            [5126, 3299],
            [20, -100],
            [-11, -57],
            [22, -63],
            [63, -61],
            [59, -137],
            [0, 0],
        ],
        [
            [5279, 2881],
            [-43, 11],
            [-147, -18],
            [-29, -13],
            [-31, -69],
            [24, -48],
            [-19, -129],
            [-13, -110],
            [29, -19],
            [76, -42],
            [30, 20],
            [9, -118],
            [-83, 1],
            [-45, 60],
            [-40, 46],
            [-84, 16],
            [-24, 57],
            [-67, -35],
            [-87, 15],
            [-37, 50],
            [-69, 10],
            [-51, -3],
            [-7, 34],
            [-37, 3],
        ],
        [
            [86, 5220],
            [13, 48],
        ],
        [
            [99, 5268],
            [119, 3],
            [25, 26],
            [35, 2],
            [43, -27],
            [34, -1],
            [36, 19],
            [22, -32],
            [-48, -24],
            [-47, 2],
            [-47, 23],
            [-40, -25],
            [-20, -1],
            [-26, -15],
            [-99, 2],
        ],
        [
            [2960, 3899],
            [-21, 16],
            [38, 122],
        ],
        [
            [978, 6798],
            [-17, 0],
            [0, 0],
            [3, -58],
            [-68, -4],
            [-35, -24],
            [-49, 0],
            [-40, 14],
            [-92, -12],
            [-35, -85],
            [-34, -8],
            [-52, -137],
            [-151, -117],
            [-36, -151],
            [-45, -48],
            [-13, -40],
            [-246, -8],
            [-2, 0],
        ],
        [
            [66, 6120],
            [5, 50],
            [42, 30],
            [36, 57],
            [-7, 36],
            [37, 77],
            [61, 69],
            [37, 18],
            [29, 63],
            [2, 58],
            [40, 68],
            [72, 39],
            [70, 111],
            [2, 2],
            [54, 42],
            [102, 12],
            [86, 74],
            [55, 29],
            [91, 91],
            [-28, 135],
            [42, 94],
            [15, 57],
            [70, 74],
            [109, 50],
            [81, 44],
            [73, 113],
            [35, 67],
            [80, -1],
            [66, -46],
            [103, 8],
            [114, -24],
            [47, -1],
        ],
        [
            [272, 4990],
            [-58, 46],
            [-46, 7],
            [-25, 31],
            [1, 16],
            [-34, 23],
            [-7, 23],
        ],
        [
            [103, 5136],
            [58, 18],
            [36, -3],
            [30, 12],
            [201, -5],
        ],
        [
            [6492, 4215],
            [-95, -123],
            [1, -397],
            [65, -89],
        ],
        [
            [6463, 3606],
            [-77, -44],
            [-27, -45],
            [-41, -8],
            [-15, -77],
            [-35, -44],
            [-21, -72],
            [-44, -36],
        ],
        [
            [6203, 3280],
            [-157, 109],
            [-7, 63],
            [-396, 221],
            [-19, 12],
        ],
        [
            [5624, 3685],
            [-1, 116],
            [31, 44],
            [54, 72],
            [40, 79],
            [-48, 125],
            [-13, 55],
            [-52, 75],
        ],
        [
            [5635, 4251],
            [68, 65],
            [74, 72],
        ],
        [
            [1082, 4264],
            [-29, -1],
            [-112, 52],
            [-99, 82],
            [-93, 60],
            [-74, 70],
        ],
        [
            [675, 4527],
            [26, 35],
            [6, 32],
            [49, 59],
            [51, 51],
        ],
        [
            [7331, 2432],
            [29, -46],
            [27, -72],
            [18, -131],
            [28, -51],
            [-11, -52],
            [-19, -32],
            [-37, 64],
            [-20, -33],
            [20, -80],
            [-9, -46],
            [-30, -26],
            [-7, -92],
            [-43, -127],
            [-54, -150],
            [-68, -206],
            [-41, -151],
            [-50, -126],
            [-89, -26],
            [-95, -46],
            [-63, 28],
            [-86, 39],
            [-30, 57],
            [-8, 97],
            [-38, 86],
            [-10, 79],
            [19, 78],
            [51, 19],
            [0, 36],
            [52, 83],
            [10, 69],
            [-25, 51],
            [-21, 69],
            [-9, 100],
            [38, 61],
            [15, 69],
            [54, 4],
            [61, 23],
            [41, 19],
            [48, 2],
            [62, 62],
            [90, 67],
            [33, 54],
            [-15, 47],
            [46, -13],
            [60, 76],
            [2, 65],
            [36, 49],
            [38, -47],
        ],
        [
            [5948, 6183],
            [-433, 0],
            [-424, 0],
            [-438, 0],
        ],
        [
            [4653, 6183],
            [0, 400],
            [0, 387],
            [-33, 88],
            [28, 67],
            [-17, 47],
            [39, 52],
        ],
        [
            [4670, 7224],
            [146, 2],
            [105, -29],
            [108, -32],
            [51, -17],
            [84, 34],
            [45, 32],
            [96, 9],
            [77, -14],
            [30, -54],
            [26, 35],
            [87, -25],
            [85, -7],
            [54, 28],
            [72, -187],
            [-31, -44],
            [-24, -82],
            [-29, -57],
            [-26, -19],
            [-36, 35],
            [-49, 49],
            [-78, 156],
            [-11, -10],
            [45, -115],
            [67, -109],
            [82, -170],
            [41, -59],
            [35, -61],
            [98, -121],
            [-22, -19],
            [3, -70],
            [128, -98],
            [19, -22],
        ],
        [
            [1386, 6506],
            [-167, -2],
            [53, -469],
            [53, -470],
            [19, -13],
            [-25, -76],
            [-438, -2],
            [-16, -24],
            [-42, 7],
            [-62, -22],
            [-76, 31],
            [-35, -3],
            [-18, -64],
            [-37, -20],
        ],
        [
            [595, 5379],
            [-72, 75],
            [-66, 80],
            [-72, 29],
            [-52, 32],
            [-61, -1],
            [-54, -24],
            [-54, 9],
            [-37, -34],
        ],
        [
            [127, 5545],
            [-10, 58],
            [31, 54],
            [13, 102],
            [-12, 108],
            [-13, 54],
            [11, 54],
            [-28, 52],
            [-58, 47],
        ],
        [
            [61, 6074],
            [24, 36],
            [428, -1],
            [-21, 158],
            [27, 56],
            [102, 9],
            [-4, 279],
            [359, -6],
            [0, 165],
        ],
        [
            [5696, 2535],
            [-31, -82],
            [31, -142],
            [38, 2],
            [39, -35],
            [46, -79],
            [9, -140],
            [-47, -23],
            [-33, -75],
            [-72, 67],
            [-8, 77],
            [23, 50],
            [-6, 44],
            [-43, 27],
            [-30, -10],
            [-63, 52],
        ],
        [
            [5549, 2268],
            [-57, 29],
            [33, 101],
            [34, 38],
            [-21, 90],
            [22, 88],
            [19, 29],
            [-28, 93],
            [-52, 48],
        ],
        [
            [5499, 2784],
            [107, -20],
            [22, -30],
            [37, -51],
            [31, -148],
        ],
        [
            [1965, 5413],
            [70, 5],
            [40, 38],
            [149, 10],
            [97, 17],
            [9, 67],
            [60, 73],
            [0, 250],
        ],
        [
            [3234, 6343],
            [172, -47],
            [62, -60],
            [77, 41],
        ],
        [
            [3545, 6277],
            [27, -170],
            [40, -28],
            [2, -34],
            [46, -38],
            [-24, -47],
            [-42, -220],
            [-6, -142],
            [-139, -103],
            [-47, -143],
            [45, -40],
            [0, -70],
            [70, -3],
            [-11, -51],
        ],
        [
            [3472, 5147],
            [-21, -2],
            [-74, 119],
            [-25, 4],
            [-85, -61],
            [-85, 32],
            [-59, 7],
            [-31, -16],
            [-64, 4],
            [-65, -47],
            [-55, -2],
            [-132, 56],
            [-52, -27],
            [-56, 2],
            [-41, 41],
            [-109, 41],
            [-117, -13],
            [-29, -24],
            [-15, -62],
            [-31, -44],
            [-8, -97],
        ],
        [
            [4458, 1882],
            [89, 25],
            [71, -6],
            [43, -25],
            [1, -9],
        ],
        [
            [4095, 1094],
            [0, -402],
            [-97, -56],
            [-59, -8],
            [-68, 21],
            [-49, 8],
            [-19, 46],
            [-43, 30],
            [-52, -54],
        ],
        [
            [3708, 679],
            [-81, 82],
            [-43, 80],
            [-24, 106],
            [-27, 79],
            [-37, 167],
            [-2, 130],
            [-14, 60],
            [-42, 45],
            [-57, 90],
            [-57, 130],
            [-24, 68],
            [-89, 107],
            [-6, 83],
        ],
        [
            [5696, 2535],
            [82, 9],
            [131, -31],
            [29, 14],
            [76, 3],
            [39, 33],
            [65, -2],
            [119, 42],
            [87, 63],
            [0, 0],
        ],
        [
            [6324, 2666],
            [0, 0],
            [18, -49],
            [-5, -108],
            [14, -96],
            [4, -170],
            [19, -53],
            [-32, -78],
            [-43, -75],
            [-69, -68],
            [-100, -41],
            [-123, -53],
            [-123, -117],
            [-42, -19],
            [-76, -78],
            [-45, -25],
            [-10, -78],
            [52, -82],
            [22, -64],
            [1, -32],
            [19, 5],
            [-3, -107],
            [-17, -50],
            [25, -19],
            [-16, -45],
            [-46, -39],
            [-90, -37],
            [-131, -58],
            [-48, -41],
            [10, -46],
            [28, -7],
            [-10, -57],
        ],
        [
            [5507, 879],
            [-83, 1],
        ],
        [
            [5424, 880],
            [-9, 48],
            [-16, 49],
        ],
        [
            [5399, 977],
            [-9, 39],
            [19, 121],
            [-28, 77],
            [-53, 154],
        ],
        [
            [5328, 1368],
            [115, 123],
            [29, 79],
            [17, 9],
            [12, 64],
            [-18, 33],
            [5, 81],
            [21, 75],
            [0, 138],
            [-57, 35],
            [-52, 8],
            [-23, 27],
            [-51, 23],
            [-91, -2],
            [-7, 40],
        ],
        [
            [5228, 2101],
            [-10, 78],
            [331, 89],
        ],
        [
            [2852, 4308],
            [-114, -39],
            [-41, 6],
            [-42, -25],
            [-87, 3],
            [-59, 68],
            [-36, 78],
            [-77, 72],
            [-82, -1],
            [-96, 0],
        ],
        [
            [5152, 3643],
            [27, -11],
            [65, 33],
        ],
        [
            [5244, 3665],
            [43, -61],
            [-6, -64],
            [-31, -14],
            [0, 0],
        ],
        [
            [667, 5143],
            [5, 34],
            [-9, 42],
            [-41, 30],
            [-22, 63],
            [-5, 67],
        ],
        [
            [5087, 638],
            [38, -33],
            [-34, -53],
            [-18, -35],
            [-61, -17],
            [-20, -35],
            [-39, -11],
            [-82, 84],
            [58, 69],
            [59, 42],
            [51, 23],
            [48, -34],
        ],
        [
            [61, 6074],
            [5, 46],
        ],
        [
            [7140, 4660],
            [76, 90],
            [49, 67],
            [0, 57],
            [0, 110],
            [1, 45],
            [0, 1],
        ],
        [
            [7266, 5030],
            [35, 3],
            [51, 16],
            [57, 11],
            [52, 37],
            [42, 0],
            [2, -30],
            [-10, -63],
            [0, -57],
            [-23, -40],
            [-30, -117],
            [-53, -122],
            [-67, -139],
            [-94, -159],
            [-93, -122],
            [-129, -148],
            [-109, -89],
            [-163, -108],
            [-102, -82],
            [-119, -132],
            [-26, -58],
            [-24, -25],
        ],
        [
            [4419, 5001],
            [2, 27],
            [-40, 32],
            [-2, 63],
            [-23, 42],
            [-38, -6],
            [11, 40],
            [28, 45],
            [-12, 45],
            [36, 33],
            [-23, 26],
            [29, 67],
            [50, 80],
            [94, -8],
            [-5, 432],
        ],
        [
            [4526, 5919],
            [1, 46],
            [126, 0],
            [0, 218],
        ],
        [
            [5948, 6183],
            [35, -107],
            [-24, -20],
            [16, -112],
            [40, -130],
            [41, -27],
            [60, -40],
        ],
        [
            [5631, 4819],
            [-15, 2],
            [2, 54],
            [-14, 37],
            [-56, 43],
            [-13, 79],
            [13, 80],
            [-50, 8],
            [-8, -25],
            [-65, -5],
            [26, -32],
            [9, -65],
            [-60, -60],
            [-54, -79],
            [-56, -11],
            [-92, 64],
            [-41, -23],
            [-12, -32],
            [-56, -20],
            [-4, -23],
            [-108, 0],
            [-15, 23],
            [-79, 4],
            [-39, -19],
            [-30, 9],
            [-56, 64],
            [-19, 30],
            [-79, -15],
            [-30, -51],
            [-28, -97],
            [-37, -20],
            [-34, -12],
        ],
        [
            [2959, 7087],
            [53, 25],
            [9, 46],
            [-11, 45],
            [75, 42],
            [33, 35],
            [54, 31],
            [6, 84],
        ],
        [
            [3178, 7395],
            [128, -38],
            [46, 9],
            [91, -18],
            [145, -48],
            [51, -97],
            [98, -21],
            [154, -46],
            [116, -54],
            [53, 28],
            [53, 50],
            [-26, 84],
            [34, 53],
            [79, 51],
            [75, 15],
            [148, -23],
            [37, -48],
            [41, -1],
            [34, -18],
            [109, -13],
            [26, -36],
        ],
        [
            [4526, 5919],
            [-436, 209],
            [-435, 208],
            [-110, -59],
        ],
        [
            [5635, 4251],
            [-67, -50],
            [-77, 0],
            [-87, -25],
            [-70, 24],
            [-45, -29],
        ],
        [
            [103, 5136],
            [-17, 84],
        ],
        [
            [99, 5268],
            [-45, 85],
            [-54, 39],
            [48, 20],
            [53, 77],
            [26, 56],
        ],
        [
            [675, 4527],
            [-29, 8],
            [-79, 44],
            [-57, 58],
            [-19, 40],
            [-13, 81],
        ],
        [
            [5424, 880],
            [-22, -49],
            [-64, -11],
            [-65, 59],
            [-1, 37],
            [30, 41],
            [10, 32],
            [32, 8],
            [55, -20],
        ],
        [
            [6633, 5036],
            [36, -20],
            [21, -45],
            [49, -46],
            [54, 0],
            [103, 28],
            [119, 13],
            [96, 34],
            [54, 7],
            [39, 20],
            [62, 3],
            [0, 0],
        ],
        [
            [2843, 7809],
            [119, 44],
            [76, -13],
            [-3, -55],
            [93, 40],
            [7, -21],
            [-54, -53],
            [-1, -51],
            [38, -27],
            [-15, -94],
            [-71, -55],
            [20, -59],
            [57, -2],
            [27, -51],
            [42, -17],
        ],
        [
            [2127, 4457],
            [-88, -23],
        ],
        [
            [5136, 1385],
            [45, -1],
            [52, -19],
            [37, 13],
            [58, -10],
        ],
        [
            [5507, 879],
            [-27, -79],
            [-13, -91],
            [-28, -49],
            [-75, -55],
            [-21, -16],
            [-46, -55],
            [-31, -56],
            [-62, -78],
            [-123, -112],
            [-77, -65],
            [-82, -50],
            [-115, -42],
            [-55, -6],
            [-14, -30],
            [-67, 16],
            [-54, -20],
            [-118, 21],
            [-66, -14],
            [-45, 6],
            [-113, -43],
            [-93, -17],
            [-67, -41],
            [-50, -3],
            [-46, 39],
            [-37, 2],
            [-47, 48],
            [-5, -15],
            [-15, 30],
            [1, 63],
            [-36, 73],
            [36, 20],
            [-3, 84],
            [-72, 101],
            [-55, 93],
            [0, 0],
            [-78, 141],
        ],
        [
            [5244, 3665],
            [38, 13],
            [120, -1],
            [222, 8],
        ],
        [
            [6203, 3280],
            [-51, -134],
            [7, -62],
            [70, -39],
            [3, -29],
            [-30, -65],
            [6, -34],
            [-7, -52],
            [38, -68],
            [45, -107],
            [40, -24],
        ],
        [
            [5499, 2784],
            [-62, 33],
            [-69, 18],
            [-43, 19],
            [-46, 27],
        ],
        [
            [5228, 2101],
            [-82, -15],
            [-63, -43],
            [-13, -38],
            [-39, -8],
            [-95, -90],
            [-60, -70],
            [-37, -3],
            [-36, 13],
            [-122, 12],
        ],
    ],
    transform: {
        scale: [0.00916174719393613, 0.009190011558244017],
        translate: [-17.62504269049066, -34.81916635512371],
    },
    objects: {
        countries: {
            type: 'GeometryCollection',
            geometries: [
                {
                    arcs: [[0, 1, 2, 3, 4]],
                    type: 'Polygon',
                    properties: {
                        name: 'Benin',
                        country: 'BJ',
                    },
                },
                {
                    arcs: [[[5, 6, 7, 8]], [[9, 10, 11]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Angola',
                        country: 'AO',
                    },
                },
                {
                    arcs: [[12, 13, 14, 15, 16, 17]],
                    type: 'Polygon',
                    properties: {
                        name: "Côte d'Ivoire",
                        country: 'CI',
                    },
                },
                {
                    arcs: [[18, 19, 20, 21]],
                    type: 'Polygon',
                    properties: {
                        name: 'Botswana',
                        country: 'BW',
                    },
                },
                {
                    arcs: [[-11, 22, 23, 24, 25, 26]],
                    type: 'Polygon',
                    properties: {
                        name: 'Congo',
                        country: 'CG',
                    },
                },
                {
                    arcs: [[-25, 27, 28, 29, 30, 31, 32, 33]],
                    type: 'Polygon',
                    properties: {
                        name: 'Cameroon',
                        country: 'CM',
                    },
                },
                {
                    arcs: [[-26, -34, 34, 35, 36, 37]],
                    type: 'Polygon',
                    properties: {
                        name: 'Central African Rep.',
                        country: 'CF',
                    },
                },
                {
                    arcs: [[-3, 38, 39, -17, 40, 41]],
                    type: 'Polygon',
                    properties: {
                        name: 'Burkina Faso',
                        country: 'BF',
                    },
                },
                {
                    arcs: [[42, 43, 44]],
                    type: 'Polygon',
                    properties: {
                        name: 'Burundi',
                        country: 'BI',
                    },
                },
                {
                    arcs: [[45, 46, 47, 48]],
                    type: 'Polygon',
                    properties: {
                        name: 'Djibouti',
                        country: 'DJ',
                    },
                },
                {
                    arcs: [[49, 50, 51, 52, 53, 54, 55, 56]],
                    type: 'Polygon',
                    properties: {
                        name: 'Algeria',
                        country: 'DZ',
                    },
                },
                {
                    arcs: [[57, -48, 58, 59, 60, 61, 62, 63]],
                    type: 'Polygon',
                    properties: {
                        name: 'Ethiopia',
                        country: 'ET',
                    },
                },
                {
                    arcs: [[-24, 64, 65, -28]],
                    type: 'Polygon',
                    properties: {
                        name: 'Gabon',
                        country: 'GA',
                    },
                },
                {
                    arcs: [[-15, 66, 67, 68, 69, 70, 71]],
                    type: 'Polygon',
                    properties: {
                        name: 'Guinea',
                        country: 'GN',
                    },
                },
                {
                    arcs: [[-18, -40, 72, 73]],
                    type: 'Polygon',
                    properties: {
                        name: 'Ghana',
                        country: 'GH',
                    },
                },
                {
                    arcs: [[-49, -58, -64, 74, 75]],
                    type: 'Polygon',
                    properties: {
                        name: 'Eritrea',
                        country: 'ER',
                    },
                },
                {
                    arcs: [[-9, 76, -12, -27, -38, 77, 78, 79, -43, 80, 81]],
                    type: 'Polygon',
                    properties: {
                        name: 'Dem. Rep. Congo',
                        country: 'CD',
                    },
                },
                {
                    arcs: [[82, 83]],
                    type: 'Polygon',
                    properties: {
                        name: 'Gambia',
                        country: 'GM',
                    },
                },
                {
                    arcs: [[-29, -66, 84]],
                    type: 'Polygon',
                    properties: {
                        name: 'Eq. Guinea',
                        country: 'GQ',
                    },
                },
                {
                    arcs: [[-53, 85, 86]],
                    type: 'Polygon',
                    properties: {
                        name: 'Morocco',
                        country: 'MA',
                    },
                },
                {
                    arcs: [[-70, 87, 88]],
                    type: 'Polygon',
                    properties: {
                        name: 'Guinea-Bissau',
                        country: 'GW',
                    },
                },
                {
                    arcs: [[-61, 89, 90, 91, 92, 93]],
                    type: 'Polygon',
                    properties: {
                        name: 'Kenya',
                        country: 'KE',
                    },
                },
                {
                    arcs: [[-14, 94, 95, -67]],
                    type: 'Polygon',
                    properties: {
                        name: 'Liberia',
                        country: 'LR',
                    },
                },
                {
                    arcs: [[96]],
                    type: 'Polygon',
                    properties: {
                        name: 'Madagascar',
                        country: 'MG',
                    },
                },
                {
                    arcs: [[97, 98, 99]],
                    type: 'Polygon',
                    properties: {
                        name: 'Egypt',
                        country: 'EG',
                    },
                },
                {
                    arcs: [[-51, 100, 101, 102, 103]],
                    type: 'Polygon',
                    properties: {
                        name: 'Mauritania',
                        country: 'MR',
                    },
                },
                {
                    arcs: [[104, 105, 106]],
                    type: 'Polygon',
                    properties: {
                        name: 'Malawi',
                        country: 'MW',
                    },
                },
                {
                    arcs: [[-4, -42, 107, -57, 108, 109, -32, 110]],
                    type: 'Polygon',
                    properties: {
                        name: 'Niger',
                        country: 'NE',
                    },
                },
                {
                    arcs: [[-7, 111, -20, 112, 113]],
                    type: 'Polygon',
                    properties: {
                        name: 'Namibia',
                        country: 'NA',
                    },
                },
                {
                    arcs: [[-105, 114, 115, 116, 117, 118, 119, 120]],
                    type: 'Polygon',
                    properties: {
                        name: 'Mozambique',
                        country: 'MZ',
                    },
                },
                {
                    arcs: [[-5, -111, -31, 121]],
                    type: 'Polygon',
                    properties: {
                        name: 'Nigeria',
                        country: 'NG',
                    },
                },
                {
                    arcs: [[-44, -80, 122, 123]],
                    type: 'Polygon',
                    properties: {
                        name: 'Rwanda',
                        country: 'RW',
                    },
                },
                {
                    arcs: [[-16, -72, 124, -101, -50, -108, -41]],
                    type: 'Polygon',
                    properties: {
                        name: 'Mali',
                        country: 'ML',
                    },
                },
                {
                    arcs: [[125]],
                    type: 'Polygon',
                    properties: {
                        name: 'Lesotho',
                        country: 'LS',
                    },
                },
                {
                    arcs: [[-52, -104, 126, -86]],
                    type: 'Polygon',
                    properties: {
                        type: 'Indeterminate',
                        name: 'W. Sahara',
                        country: 'EH',
                    },
                },
                {
                    arcs: [[-60, 127, 128, -90]],
                    type: 'Polygon',
                    properties: {
                        name: 'Somalia',
                        country: 'SO',
                    },
                },
                {
                    arcs: [[-36, 129, 130, -98, 131, -75, -63, 132]],
                    type: 'Polygon',
                    properties: {
                        name: 'Sudan',
                        country: 'SD',
                    },
                },
                {
                    arcs: [[-56, 133, 134, -99, -131, 135, -109]],
                    type: 'Polygon',
                    properties: {
                        name: 'Libya',
                        country: 'LY',
                    },
                },
                {
                    arcs: [[-37, -133, -62, -94, 136, -78]],
                    type: 'Polygon',
                    properties: {
                        name: 'S. Sudan',
                        country: 'SDS',
                    },
                },
                {
                    arcs: [[-71, -89, 137, -84, 138, -102, -125]],
                    type: 'Polygon',
                    properties: {
                        name: 'Senegal',
                        country: 'SN',
                    },
                },
                {
                    arcs: [[-68, -96, 139]],
                    type: 'Polygon',
                    properties: {
                        name: 'Sierra Leone',
                        country: 'SL',
                    },
                },
                {
                    arcs: [[-118, 140]],
                    type: 'Polygon',
                    properties: {
                        name: 'Swaziland',
                        country: 'SZ',
                    },
                },
                {
                    arcs: [[-47, 141, -128, -59]],
                    type: 'Polygon',
                    properties: {
                        type: 'Indeterminate',
                        name: 'Somaliland',
                        country: 'SO',
                    },
                },
                {
                    arcs: [[-110, -136, -130, -35, -33]],
                    type: 'Polygon',
                    properties: {
                        name: 'Chad',
                        country: 'TD',
                    },
                },
                {
                    arcs: [[-55, 142, -134]],
                    type: 'Polygon',
                    properties: {
                        name: 'Tunisia',
                        country: 'TN',
                    },
                },
                {
                    arcs: [[-2, 143, -73, -39]],
                    type: 'Polygon',
                    properties: {
                        name: 'Togo',
                        country: 'TG',
                    },
                },
                {
                    arcs: [[-19, 144, -119, -141, -117, 145, -113], [-126]],
                    type: 'Polygon',
                    properties: {
                        name: 'South Africa',
                        country: 'ZA',
                    },
                },
                {
                    arcs: [[-124, 146, -92, 147, -115, -107, 148, -81, -45]],
                    type: 'Polygon',
                    properties: {
                        name: 'Tanzania',
                        country: 'TZ',
                    },
                },
                {
                    arcs: [[-6, -82, -149, -106, -121, 149, -21, -112]],
                    type: 'Polygon',
                    properties: {
                        name: 'Zambia',
                        country: 'ZM',
                    },
                },
                {
                    arcs: [[-79, -137, -93, -147, -123]],
                    type: 'Polygon',
                    properties: {
                        name: 'Uganda',
                        country: 'UG',
                    },
                },
                {
                    arcs: [[-22, -150, -120, -145]],
                    type: 'Polygon',
                    properties: {
                        name: 'Zimbabwe',
                        country: 'ZW',
                    },
                },
            ],
        },
    },
};

export default data;
